import NavigationBreadcrumbs from '@/navigation/components/NavigationBreadcrumbs'
import css from './systemEvents.module.css'
import MainLayout from '@/shared/Layouts/MainLayout'
import SearchInput from '@/shared/Inputs/SearchInput'
import SystemEventsTypeDropdown from './components/SystemEventsTypeDropdown'
import { useRecoilState } from 'recoil'
import systemEventFiltersAtom, { ISystemEventFiltersState } from './systemEventFilters.atom.ts'
import SystemEventsTable from './components/SystemEventsTable'
import AntDateRangePicker from '@/shared/Inputs/DatePickers/AntDateRangePicker'
import useTitle from '@/shared/hooks/useTitle'

const SystemEventsPage = () => {
  useTitle('События системы')
  const [filtersState, setFiltersState] = useRecoilState(systemEventFiltersAtom)

  const handleFilterChange = <T extends keyof ISystemEventFiltersState>(value: ISystemEventFiltersState[T], key: T) => {
    setFiltersState((prev) => ({ ...prev, [key]: value }))
  }

  const handleDate = (startTs: number, endTs: number) => {
    handleFilterChange(startTs ? new Date(startTs) : null, 'created_gte')
    handleFilterChange(endTs ? new Date(endTs) : null, 'created_lte')
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">События системы</h2>
          </div>
          <div className="inline-flex-gap gap24" style={{ height: '100%' }}>
            <div className={css.mainCard}>
              <div className={css.wrapperSearch}>
                <div className={css.searchInput}>
                  <SearchInput
                    value={filtersState.search}
                    name="search"
                    onChange={handleFilterChange}
                    placeHolder="Поиск по событиям"
                  />
                </div>
                <div className={css.dateFilter}>
                  <AntDateRangePicker
                    allowSelectInFuture={false}
                    onChange={handleDate}
                    endTs={filtersState.created_lte?.getTime()}
                    startTs={filtersState.created_gte?.getTime()}
                    withTime={true}
                  />
                </div>
                <div className={css.typeFilter}>
                  <SystemEventsTypeDropdown statuses={filtersState.type} onChange={handleFilterChange} name="type" />
                </div>
              </div>
              <SystemEventsTable filterState={filtersState} />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default SystemEventsPage
